// Returns the first whole character (code point) of a string, so names that
// start with an emoji or other non-BMP character yield a usable initial
// instead of half a surrogate pair. codePointAt reads only the first character
// (no array allocation); String.fromCodePoint turns that number back into text.
function firstChar(word) {
    return String.fromCodePoint(word.codePointAt(0));
}

export function toInitials(name) {
    if (!name || typeof name !== 'string') return '?';
    const formattedName = name.trim().toUpperCase().normalize('NFC');
    if (formattedName.length === 0) return '?';

    const words = formattedName.split(' ');

    if (words.length === 1) return firstChar(words[0]);
    return firstChar(words[0]) + firstChar(words[words.length - 1]);
}

export function colorFromName(name) {
    if (!name || typeof name !== 'string') {
        return `hsl(130, 60%, 35%)`;
    }
    const formattedName = name.trim();
    if (formattedName.length === 0) return `hsl(130, 60%, 35%)`;

    let hash = 0;
    for (let i = 0; i < formattedName.length; i++) {
        hash = (hash << 5) - hash + formattedName.charCodeAt(i);
        hash |= 0;
    }
    hash = Math.abs(hash);
    return `hsl(${hash % 360}, 60%, 35%)`;
}
